import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import { AirportI18n } from '@common/interfaces/master/airport_i18n_all';
import { Lounge, PassengerLoungeMap } from '@common/interfaces/mybooking/order-services.interface';
import { MasterJsonKeyPrefix } from '@conf/asw-master.config';
import { DialogClickType } from '@lib/interfaces';
import { DialogDisplayService } from '@lib/services';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoungeServiceRequestService extends ServicingBaseClass {
  airportI18nAll!: AirportI18n;
  screenInformationChangeFlag = new BehaviorSubject<boolean>(false);
  constructor(private _dialogService: DialogDisplayService) {
    super();
  }

  // (共通No.1) 空港名称取得処理
  onHandleCommonNo1(airport_code?: string): string {
    return this.airportI18nAll?.[String(airport_code)]?.[0].airport_name ?? '';
  }

  getLoungeService(flightId?: string, travelerId?: string, lounge?: Lounge): PassengerLoungeMap {
    const loungeServiceOfTraveler = lounge?.[String(flightId)]?.[String(travelerId)] ?? ({} as PassengerLoungeMap);
    return loungeServiceOfTraveler as PassengerLoungeMap;
  }

  openDialogPromise(messageId: string): Promise<DialogClickType> {
    return new Promise((resolve) => {
      this._dialogService
        .openDialog({ message: MasterJsonKeyPrefix.DYNAMIC + messageId })
        .buttonClick$.subscribe((result) => resolve(result.clickType));
    });
  }

  destroy() {}
}
